import type { AccessioningPanelOption } from "../services/accessioningPanels.service";

export type StainSelectionContext = "ordinary" | "qc-accessioning";

export function isControlStainCode(code: string): boolean {
  return code.startsWith("Control -");
}

export function isSelectableStainCode(
  code: string,
  context: StainSelectionContext = "ordinary"
): boolean {
  return context === "qc-accessioning" || !isControlStainCode(code);
}

export function isSelectablePanel(
  panel: AccessioningPanelOption,
  context: StainSelectionContext = "ordinary"
): boolean {
  return panel.components.every((component) =>
    isSelectableStainCode(component.stainCode, context)
  );
}
